import { graphql } from "react-relay";

export const SWITCH_ACCOUNT_MUTATION = graphql`
	mutation accountSwitcher_SwitchAccountMutation($input: SwitchAccountInput!) {
		Auth {
			switchAccount(input: $input) {
				jwtTokens {
					accessToken
					refreshToken
				}
				clientMutationId
			}
		}
	}
`;
